import {arrayMove as dndKitArrayMove} from '@dnd-kit/sortable';
import {
  MouseSensor as LibMouseSensor,
  KeyboardSensor as LibKeyboardSensor,
  PointerSensor as LibPointerSensor
} from '@dnd-kit/core';
import _ from 'lodash';

export const removeAtIndex = ({array, index}) => {
  return [...array.slice(0, index), ...array.slice(index + 1)];
};

export const insertAtIndex = ({array, index, item}) => {
  return [...array.slice(0, index), item, ...array.slice(index)];
};

export const arrayMove = ({array, fromIndex, toIndex}) => {
  return dndKitArrayMove(array, fromIndex, toIndex);
};

export const moveBetweenContainers = ({map, fromKey, toKey, fromIndex, toIndex, item}) => {
  const updatedMap = new Map(map);

  updatedMap.set(fromKey, removeAtIndex({array: updatedMap.get(fromKey), index: fromIndex}));

  updatedMap.set(toKey, insertAtIndex({array: updatedMap.get(toKey), index: toIndex, item}));

  return updatedMap;
};

export class MouseSensor extends LibMouseSensor {
  static activators = [
    {
      eventName: 'onMouseDown',
      handler: ({nativeEvent: event}) => {
        return shouldHandleEvent(event.target);
      }
    }
  ];
}

export class KeyboardSensor extends LibKeyboardSensor {
  static activators = [
    {
      eventName: 'onKeyDown',
      handler: ({nativeEvent: event}) => {
        return shouldHandleEvent(event.target);
      }
    }
  ];
}

export class PointerSensor extends LibPointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown',
      handler: ({nativeEvent: event}) => {
        return shouldHandleEvent(event.target);
      }
    }
  ];
}

function shouldHandleEvent(element) {
  let cur = element;

  while (cur) {
    if (cur.dataset && cur.dataset.noDnd) {
      return false;
    }
    cur = cur.parentElement;
  }

  return true;
}
